"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * DTO object representing one UI row in approval report PM.
 * @author Zdeněk Straka
 * @author Adam Drda
 */


var ApprovalReportPMRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ApprovalReportPMRowDTO, _DomainObject_1$Domai);

  function ApprovalReportPMRowDTO(id, nodeId, reportId, level, path, isGroup, entity, entityId, title, // promo
  promotionExtId, promotionTypeId, promoTypeName, promotionDiscount, storeSpecification, promoWFState, // 4Box
  cd, cm, // window
  windowTypeId, windowTypeName, windowName, windowWFState, // other
  startDate, daysValid, workflowNote, windowCount, skuCount, // KPIs
  sales, promoVolume, gm, gmPercentage, proxyBm2, proxyBm2Percentage, //
  snapshotMissing) {
    var _this;

    _classCallCheck(this, ApprovalReportPMRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApprovalReportPMRowDTO).call(this));
    _this.id = id;
    _this.nodeId = nodeId;
    _this.reportId = reportId;
    _this.level = level;
    _this.path = path;
    _this.isGroup = isGroup;
    _this.entity = entity;
    _this.entityId = entityId;
    _this.title = title;
    _this.promotionExtId = promotionExtId;
    _this.promotionTypeId = promotionTypeId;
    _this.promoTypeName = promoTypeName;
    _this.promotionDiscount = promotionDiscount;
    _this.storeSpecification = storeSpecification;
    _this.promoWFState = promoWFState;
    _this.cd = cd;
    _this.cm = cm;
    _this.windowTypeId = windowTypeId;
    _this.windowTypeName = windowTypeName;
    _this.windowName = windowName;
    _this.windowWFState = windowWFState;
    _this.startDate = startDate;
    _this.daysValid = daysValid;
    _this.workflowNote = workflowNote;
    _this.windowCount = windowCount;
    _this.skuCount = skuCount;
    _this.sales = sales;
    _this.promoVolume = promoVolume;
    _this.gm = gm;
    _this.gmPercentage = gmPercentage;
    _this.proxyBm2 = proxyBm2;
    _this.proxyBm2Percentage = proxyBm2Percentage;
    _this.snapshotMissing = snapshotMissing;
    return _this;
  }

  return ApprovalReportPMRowDTO;
}(DomainObject_1.DomainObject);

exports.ApprovalReportPMRowDTO = ApprovalReportPMRowDTO;

ApprovalReportPMRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ApprovalReportPMRowDTO.name);
  return {
    id: builder.str('id'),
    nodeId: builder.str('nodeId'),
    reportId: builder.str('reportId'),
    level: builder.num('level'),
    path: builder.arr(builder.str('path')),
    isGroup: builder.bool('isGroup'),
    entity: builder.opt(builder.str('entity')),
    entityId: builder.opt(builder.str('entityId')),
    title: builder.opt(builder.str('title')),
    // promo
    promotionExtId: builder.opt(builder.str('promotionExtId')),
    promotionTypeId: builder.opt(builder.str('promotionTypeId')),
    promoTypeName: builder.opt(builder.str('promoTypeName')),
    promotionDiscount: builder.opt(builder.bigNum('promotionDiscount')),
    storeSpecification: builder.opt(builder.str('storeSpecification')),
    promoWFState: builder.opt(builder.str('promoWFState')),
    // 4Box
    cd: builder.opt(builder.str('cd')),
    cm: builder.opt(builder.str('cm')),
    // window
    windowTypeId: builder.opt(builder.str('windowTypeId')),
    windowTypeName: builder.opt(builder.str('windowTypeName')),
    windowName: builder.opt(builder.str('windowName')),
    windowWFState: builder.opt(builder.str('windowWFState')),
    // other
    startDate: builder.opt(builder.date('startDate', DateParser_1.DateParser.ISO_PATTERN)),
    daysValid: builder.opt(builder.num('daysValid')),
    workflowNote: builder.opt(builder.str('workflowNote')),
    windowCount: builder.opt(builder.num('windowCount')),
    skuCount: builder.opt(builder.num('skuCount')),
    // kpi
    sales: builder.opt(builder.data('sales', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })),
    promoVolume: builder.opt(builder.data('promoVolume', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })),
    gm: builder.opt(builder.data('gm', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })),
    gmPercentage: builder.opt(builder.data('gmPercentage', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })),
    proxyBm2: builder.opt(builder.data('proxyBm2', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })),
    proxyBm2Percentage: builder.opt(builder.data('proxyBm2Percentage', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })),
    snapshotMissing: builder.opt(builder.bool('snapshotMissing'))
  };
}();